// @flow
import type { State as DeviceState, Action } from './types';

const initialState = {
  host: '',
  deviceId: '',
  deviceName: '',
  deviceOs: '',
  clientIp: '',
  isFireTv: false,
  googleAdvertisingId: '',
};

const reducer = (state: DeviceState = initialState, action: ?Action): DeviceState => {
  if (!action) return state;

  switch (action.type) {
    case 'SET_DEVICE_NAME': {
      const { deviceName } = action;
      return {
        ...state,
        deviceName,
      };
    }
    case 'SET_IS_FIRE_TV': {
      const { isFireTv } = action;
      return {
        ...state,
        isFireTv,
      };
    }
    case 'SET_GOOGLE_ADVERTISING_ID': {
      const { googleAdvertisingId } = action;
      return {
        ...state,
        googleAdvertisingId,
      };
    }
    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
